// src/constants.ts
var ELEMENT_H1 = "h1";
var ELEMENT_H2 = "h2";
var ELEMENT_H3 = "h3";
var ELEMENT_H4 = "h4";
var ELEMENT_H5 = "h5";
var ELEMENT_H6 = "h6";
var KEYS_HEADING = [
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6
];

// src/createHeadingPlugin.ts
import {
  createPluginFactory,
  onKeyDownToggleElement
} from "@udecode/plate-common";
var createHeadingPlugin = createPluginFactory({
  key: "heading",
  options: {
    levels: 6
  },
  then: (editor, { options: { levels } = {} }) => {
    const plugins = [];
    for (let level = 1; level <= levels; level++) {
      const key = KEYS_HEADING[level - 1];
      const plugin = {
        key,
        isElement: true,
        deserializeHtml: {
          rules: [
            {
              validNodeName: `H${level}`
            }
          ]
        },
        handlers: {
          onKeyDown: onKeyDownToggleElement
        },
        options: {}
      };
      if (level < 4) {
        plugin.options.hotkey = [`mod+opt+${level}`, `mod+shift+${level}`];
      }
      plugins.push(plugin);
    }
    return {
      plugins
    };
  }
});
export {
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  KEYS_HEADING,
  createHeadingPlugin
};
//# sourceMappingURL=index.mjs.map